import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

const inputClasses =
  'w-full rounded-md border border-stone-800 bg-stone-900 px-3 py-2 text-sm font-sans ' +
  'text-stone-100 placeholder:text-stone-700 ' +
  'focus:border-amber-700/60 focus:outline-none focus:ring-1 focus:ring-amber-700/40 ' +
  'disabled:cursor-not-allowed disabled:opacity-60';

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(inputClasses, invalid && 'border-red-700/60 focus:border-red-700', className)}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  );
});
